import { Clickable, Col, Icon, Row, SegmentControl, Shoutout, Sidepanel, Text } from 'components';
import { theme } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ShoutoutsPage = ({ visible, setVisible, data }) => {
  const [option, setOption] = useState(1),
    [sortedData, setSortedData] = useState([]),
    { t } = useTranslation(),
    { isMobile } = useSelector((state) => state.appState),
    options = [t('common.trending'), t('common.latest')];

  useEffect(() => {
    setSortedData(
      [...data].sort((a, b) =>
        option === 0
          ? Object.values(b.reactionCounts).reduce((a, b) => a + b) -
            Object.values(a.reactionCounts).reduce((a, b) => a + b)
          : new Date(b.createdAt) - new Date(a.createdAt)
      )
    );
  }, [option]);

  return (
    <Sidepanel
      visible={visible}
      closeModal={() => setVisible(false)}
      isMobile={isMobile}
      wid={617}
      title={
        <Row between center ht={isMobile ? '44px' : '88px'} pad={isMobile ? '16px' : '0 24px'}>
          <Text h2>{t('common.shoutouts')}</Text>

          <Row center noFlexs>
            {!isMobile && (
              <SegmentControl
                small
                options={options}
                selectedIdx={option}
                handleSelect={setOption}
                textStyle={{ b2: true, marg: '9px 24px' }}
              />
            )}

            <Clickable marg="0 0 0 21px" onClick={() => setVisible(false)}>
              <Icon type="close" col={theme.GREY_50} dimensions={14} />
            </Clickable>
          </Row>
        </Row>
      }
    >
      {isMobile && (
        <SegmentControl
          small
          options={options}
          selectedIdx={option}
          handleSelect={setOption}
          textStyle={{ b2: true, marg: '9px 24px' }}
          marg="0 0 16px 0"
        />
      )}

      {sortedData.map((x, i) => (
        <Col marg="0 0 12px">
          <Shoutout item={x} wide />
        </Col>
      ))}
    </Sidepanel>
  );
};

export default ShoutoutsPage;
